import fetchJsonp from './fetchJsonp'
const SHOWID = 'VZGNJj'
const AD_CALLBACK = 'jsonpcallback'
let reqtimes = 0

export function getAdData() {
	reqtimes ++
	const ads_url = `https://show-g.mediav.com/s?type=1&of=4&newf=1&scheme=https&showid=${SHOWID}&uid=${get_uuid()}&reqtimes=${reqtimes}&jsonp=${AD_CALLBACK}&refurl=${document.referrer}&impct=10`
	return new Promise(resolve => {
		fetchJsonp(ads_url, { jsonpCallbackFunction: AD_CALLBACK})
			.then(response => response.json()).then(res => {
				console.log(res)
				if (res && res.ads && res.ads.length) resolve(res.ads)
				else {
					resolve('nodata')
				}
			}).catch(err => {
				resolve('timeout')
			})
	})
}
//加载图片资源
export function loadImg(url) {
  var _dh = document.createElement("img");
  if (_dh.readyState) {
    _dh.onreadystatechange = function () {
      if (_dh.readyState == 'loaded' || _dh.readyState == 'complete') {
        _dh.onreadystatechange = null;
        document.getElementsByTagName("head")[0].removeChild(_dh);
      }
    }
  } else {
    _dh.onload = function () {
      _dh.onload = null;
      document.getElementsByTagName("head")[0].removeChild(_dh);
    }
  }
  document.getElementsByTagName("head")[0].appendChild(_dh);
  _dh.setAttribute("src", url);
}

function time33 (str){
  for(var i = 0, len = str.length,hash = 5381; i < len; ++i){
     hash += (hash << 5) + str.charAt(i).charCodeAt();
  };
  return hash & 0x7fffffff;
};

function get_uuid () {
  if (window.uid != undefined) {
      return window.uid;
  }
  var d = new Date().getTime() - 0
  var s = time33(window.location.href);
  var uid = ""
  uid = "" + s + d + Math.random()+Math.random();
  uid = uid.replace(/\./g, "").substring(0, 32);
  window.uid = uid;
  return uid
}

export function adClickCount(curl, clktk, offset_x, offset_y, w, h) {
	window.parent.postMessage(replaceMacros(offset_x, offset_y, w, h, curl), '*');
	if (clktk && typeof clktk === 'object') {
    for (let item of clktk) {
      const rdn = Math.floor(Math.random()*100) + new Date().getTime()
      item.search(/\?/) >= 0 ? item += `&_rdn=${rdn}` : `?_rdn=${rdn}`
      loadImg(replaceMacros(offset_x, offset_y, w, h, item))
    }
  }
}

// 宏替换
function replaceMacros (offset_x, offset_y, w, h, url){
  url = url
    .replace('__EVENT_TIME_START__', window.lastMouseDownTime + '')
    .replace('__EVENT_TIME_END__', window.lastMouseUpTime + '')
    .replace('__OFFSET_X__', offset_x + '')
    .replace('__OFFSET_Y__', offset_y + '')
    .replace('__ADSPACE_W__', w + '')
    .replace('__ADSPACE_H__', h + '')
  return url;
}

export function adExposureCount (w, h, imptk) {
  if (imptk && typeof imptk === 'object') {
    for (let item of imptk) {
      const rdn = Math.floor(Math.random()*100) + new Date().getTime()
      item.search(/\?/) >= 0 ? item += `&_rdn=${rdn}` : `?_rdn=${rdn}`
      loadImg(replaceMacros(null, null, w, h, item))
    }
  }
}
